const fields = [
  "cultivo_id",
  "tipo_etiqueta_id",
  "peso_envase_id",
  "tipo_caja_id",
  "etiqueta_id",
  "palet_id",
  "bultos",
];

const resetValues = {
  cultivo_id: 0,
  tipo_etiqueta_id: 0,
  peso_envase_id: 0,
  tipo_caja_id: 0,
  etiqueta_id: 0,
  palet_id: 0,
  bultos: "",
};

export const handleChangeValue = (setFieldValue, field, value) => {
  setFieldValue(field, value);

  const index = fields.findIndex((item) => item === field);

  for (let i = index + 1; i < fields.length; i++) {
    const currentField = fields[i];
    setFieldValue(currentField, resetValues[currentField]);
  }
};

export function esEnteroMayorACero(valor) {
  if (typeof valor === "number") {
    return Number.isInteger(valor) && valor > 0;
  }

  if (typeof valor === "string") {
    return /^[1-9]\d*$/.test(valor);
  }

  return false;
}
